import logo from "../../assets/logo.png";

export const headerContent = {
    logo,

    phone: {
        number: "9546852545",
        link: "tel:+9546522545",
    },

    // search: {
    //     placeholder: "Search news articles...",
    //     redirectPath: "/news",
    // },

    navItems: [
        { name: "Home", path: "/" },
        { name: "Products", path: "/products" },
        // { name: "News", path: "/news" },
        { name: "Contact Us", path: "/contact" },
    ],
};